/* tslint:disable */
/* eslint-disable */
/* @relayHash 7a1054bd79ce78db3e47fe5200dc4c51 */

import { ConcreteRequest } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type ClassroomPage_pageQueryVariables = {
    identifier: string;
};
export type ClassroomPage_pageQueryResponse = {
    readonly viewer: {
        readonly user: {
            readonly id: string;
        } | null;
        readonly " $fragmentRefs": FragmentRefs<"NavHeader_viewer" | "PageLoading_viewer" | "ClassroomViewer_viewer" | "DashboardLayout_viewer">;
    } | null;
    readonly classroomByIdentifier: {
        readonly id: string;
        readonly " $fragmentRefs": FragmentRefs<"ClassroomViewer_classroom">;
    } | null;
};
export type ClassroomPage_pageQuery = {
    readonly response: ClassroomPage_pageQueryResponse;
    readonly variables: ClassroomPage_pageQueryVariables;
};



/*
query ClassroomPage_pageQuery(
  $identifier: String!
) {
  viewer {
    ...NavHeader_viewer
    ...PageLoading_viewer
    ...ClassroomViewer_viewer
    ...DashboardLayout_viewer
    user {
      id
    }
  }
  classroomByIdentifier(identifier: $identifier) {
    id
    ...ClassroomViewer_classroom
  }
}

fragment AddWorksheetModal_classroom on Classroom {
  id
  classroomWorksheets(first: 500) {
    edges {
      node {
        worksheet {
          id
        }
        id
        __typename
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}

fragment ClassroomActions_classroom on Classroom {
  id
}

fragment ClassroomActions_viewer on Viewer {
  user {
    isAdmin
    classroomMemberships {
      id
      level
      classroom {
        id
      }
    }
    id
  }
}

fragment ClassroomViewer_classroom on Classroom {
  id
  identifier
  title
  description
  numActiveMemberships
  numClassroomWorksheets
  requiresApproval
  ...ClassroomActions_classroom
  ...PendingMemberships_classroom
  ...WorksheetsTab_classroom
  ...MembersTab_classroom
  ...JoinClassroomModal_classroom
  ...AddWorksheetModal_classroom
  ...EditClassroomModal_classroom
}

fragment ClassroomViewer_viewer on Viewer {
  ...ClassroomActions_viewer
  user {
    id
    isAdmin
    classroomMemberships {
      level
      classroom {
        id
      }
      id
    }
  }
}

fragment DashboardLayout_viewer on Viewer {
  user {
    id
    isAdmin
    accountType
    isUpgradedTeacher
    classroomMemberships {
      level
      classroom {
        id
        title
        identifier
      }
      id
    }
  }
}

fragment EditClassroomModal_classroom on Classroom {
  id
  title
  description
  requiresApproval
}

fragment FeedbackModal_viewer on Viewer {
  user {
    id
  }
}

fragment JoinClassroomModal_classroom on Classroom {
  id
  title
  description
  requiresApproval
}

fragment MembersTab_classroom on Classroom {
  id
}

fragment NavHeader_viewer on Viewer {
  ...FeedbackModal_viewer
  user {
    id
    username
    isAdmin
    createdAt
    isUpgradedTeacher
    accountType
    classroomMemberships {
      level
      classroom {
        id
        title
        identifier
      }
      id
    }
    worksheets(first: 1) {
      edges {
        node {
          id
        }
      }
    }
  }
}

fragment PageLoading_viewer on Viewer {
  ...NavHeader_viewer
}

fragment PendingMembership_classroomMembership on ClassroomMembership {
  id
  user {
    id
    username
    isUpgradedTeacher
  }
  classroom {
    id
  }
}

fragment PendingMemberships_classroom on Classroom {
  pendingMemberships(first: 100) {
    edges {
      node {
        id
        level
        ...PendingMembership_classroomMembership
      }
    }
  }
}

fragment WorksheetsTab_classroom on Classroom {
  id
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "identifier",
    "type": "String!",
    "defaultValue": null
  }
],
v1 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v2 = [
  (v1/*: any*/)
],
v3 = [
  {
    "kind": "Variable",
    "name": "identifier",
    "variableName": "identifier"
  }
],
v4 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "username",
  "args": null,
  "storageKey": null
},
v5 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "isUpgradedTeacher",
  "args": null,
  "storageKey": null
},
v6 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "level",
  "args": null,
  "storageKey": null
},
v7 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "title",
  "args": null,
  "storageKey": null
},
v8 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "identifier",
  "args": null,
  "storageKey": null
},
v9 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 500
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "ClassroomPage_pageQuery",
    "type": "Root",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "user",
            "storageKey": null,
            "args": null,
            "concreteType": "User",
            "plural": false,
            "selections": (v2/*: any*/)
          },
          {
            "kind": "FragmentSpread",
            "name": "NavHeader_viewer",
            "args": null
          },
          {
            "kind": "FragmentSpread",
            "name": "PageLoading_viewer",
            "args": null
          },
          {
            "kind": "FragmentSpread",
            "name": "ClassroomViewer_viewer",
            "args": null
          },
          {
            "kind": "FragmentSpread",
            "name": "DashboardLayout_viewer",
            "args": null
          }
        ]
      },
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "classroomByIdentifier",
        "storageKey": null,
        "args": (v3/*: any*/),
        "concreteType": "Classroom",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "kind": "FragmentSpread",
            "name": "ClassroomViewer_classroom",
            "args": null
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "ClassroomPage_pageQuery",
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "viewer",
        "storageKey": null,
        "args": null,
        "concreteType": "Viewer",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "user",
            "storageKey": null,
            "args": null,
            "concreteType": "User",
            "plural": false,
            "selections": [
              (v1/*: any*/),
              (v4/*: any*/),
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "isAdmin",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "createdAt",
                "args": null,
                "storageKey": null
              },
              (v5/*: any*/),
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "accountType",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "classroomMemberships",
                "storageKey": null,
                "args": null,
                "concreteType": "ClassroomMembership",
                "plural": true,
                "selections": [
                  (v6/*: any*/),
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "classroom",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Classroom",
                    "plural": false,
                    "selections": [
                      (v1/*: any*/),
                      (v7/*: any*/),
                      (v8/*: any*/)
                    ]
                  },
                  (v1/*: any*/)
                ]
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "worksheets",
                "storageKey": "worksheets(first:1)",
                "args": [
                  {
                    "kind": "Literal",
                    "name": "first",
                    "value": 1
                  }
                ],
                "concreteType": "WorksheetConnection",
                "plural": false,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "edges",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "WorksheetEdge",
                    "plural": true,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "node",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "Worksheet",
                        "plural": false,
                        "selections": (v2/*: any*/)
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      },
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "classroomByIdentifier",
        "storageKey": null,
        "args": (v3/*: any*/),
        "concreteType": "Classroom",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          (v8/*: any*/),
          (v7/*: any*/),
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "description",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "numActiveMemberships",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "numClassroomWorksheets",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "requiresApproval",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "pendingMemberships",
            "storageKey": "pendingMemberships(first:100)",
            "args": [
              {
                "kind": "Literal",
                "name": "first",
                "value": 100
              }
            ],
            "concreteType": "ClassroomMembershipConnection",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "edges",
                "storageKey": null,
                "args": null,
                "concreteType": "ClassroomMembershipEdge",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "node",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "ClassroomMembership",
                    "plural": false,
                    "selections": [
                      (v1/*: any*/),
                      (v6/*: any*/),
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "user",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "User",
                        "plural": false,
                        "selections": [
                          (v1/*: any*/),
                          (v4/*: any*/),
                          (v5/*: any*/)
                        ]
                      },
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "classroom",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "Classroom",
                        "plural": false,
                        "selections": (v2/*: any*/)
                      }
                    ]
                  }
                ]
              }
            ]
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "classroomWorksheets",
            "storageKey": "classroomWorksheets(first:500)",
            "args": (v9/*: any*/),
            "concreteType": "ClassroomWorksheetConnection",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "edges",
                "storageKey": null,
                "args": null,
                "concreteType": "ClassroomWorksheetEdge",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "node",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "ClassroomWorksheet",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "worksheet",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "Worksheet",
                        "plural": false,
                        "selections": (v2/*: any*/)
                      },
                      (v1/*: any*/),
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "__typename",
                        "args": null,
                        "storageKey": null
                      }
                    ]
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "cursor",
                    "args": null,
                    "storageKey": null
                  }
                ]
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "pageInfo",
                "storageKey": null,
                "args": null,
                "concreteType": "PageInfo",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "endCursor",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "hasNextPage",
                    "args": null,
                    "storageKey": null
                  }
                ]
              }
            ]
          },
          {
            "kind": "LinkedHandle",
            "alias": null,
            "name": "classroomWorksheets",
            "args": (v9/*: any*/),
            "handle": "connection",
            "key": "AddWorksheetModal_classroomWorksheets",
            "filters": null
          }
        ]
      }
    ]
  },
  "params": {
    "operationKind": "query",
    "name": "ClassroomPage_pageQuery",
    "id": null,
    "text": "query ClassroomPage_pageQuery(\n  $identifier: String!\n) {\n  viewer {\n    ...NavHeader_viewer\n    ...PageLoading_viewer\n    ...ClassroomViewer_viewer\n    ...DashboardLayout_viewer\n    user {\n      id\n    }\n  }\n  classroomByIdentifier(identifier: $identifier) {\n    id\n    ...ClassroomViewer_classroom\n  }\n}\n\nfragment AddWorksheetModal_classroom on Classroom {\n  id\n  classroomWorksheets(first: 500) {\n    edges {\n      node {\n        worksheet {\n          id\n        }\n        id\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n\nfragment ClassroomActions_classroom on Classroom {\n  id\n}\n\nfragment ClassroomActions_viewer on Viewer {\n  user {\n    isAdmin\n    classroomMemberships {\n      id\n      level\n      classroom {\n        id\n      }\n    }\n    id\n  }\n}\n\nfragment ClassroomViewer_classroom on Classroom {\n  id\n  identifier\n  title\n  description\n  numActiveMemberships\n  numClassroomWorksheets\n  requiresApproval\n  ...ClassroomActions_classroom\n  ...PendingMemberships_classroom\n  ...WorksheetsTab_classroom\n  ...MembersTab_classroom\n  ...JoinClassroomModal_classroom\n  ...AddWorksheetModal_classroom\n  ...EditClassroomModal_classroom\n}\n\nfragment ClassroomViewer_viewer on Viewer {\n  ...ClassroomActions_viewer\n  user {\n    id\n    isAdmin\n    classroomMemberships {\n      level\n      classroom {\n        id\n      }\n      id\n    }\n  }\n}\n\nfragment DashboardLayout_viewer on Viewer {\n  user {\n    id\n    isAdmin\n    accountType\n    isUpgradedTeacher\n    classroomMemberships {\n      level\n      classroom {\n        id\n        title\n        identifier\n      }\n      id\n    }\n  }\n}\n\nfragment EditClassroomModal_classroom on Classroom {\n  id\n  title\n  description\n  requiresApproval\n}\n\nfragment FeedbackModal_viewer on Viewer {\n  user {\n    id\n  }\n}\n\nfragment JoinClassroomModal_classroom on Classroom {\n  id\n  title\n  description\n  requiresApproval\n}\n\nfragment MembersTab_classroom on Classroom {\n  id\n}\n\nfragment NavHeader_viewer on Viewer {\n  ...FeedbackModal_viewer\n  user {\n    id\n    username\n    isAdmin\n    createdAt\n    isUpgradedTeacher\n    accountType\n    classroomMemberships {\n      level\n      classroom {\n        id\n        title\n        identifier\n      }\n      id\n    }\n    worksheets(first: 1) {\n      edges {\n        node {\n          id\n        }\n      }\n    }\n  }\n}\n\nfragment PageLoading_viewer on Viewer {\n  ...NavHeader_viewer\n}\n\nfragment PendingMembership_classroomMembership on ClassroomMembership {\n  id\n  user {\n    id\n    username\n    isUpgradedTeacher\n  }\n  classroom {\n    id\n  }\n}\n\nfragment PendingMemberships_classroom on Classroom {\n  pendingMemberships(first: 100) {\n    edges {\n      node {\n        id\n        level\n        ...PendingMembership_classroomMembership\n      }\n    }\n  }\n}\n\nfragment WorksheetsTab_classroom on Classroom {\n  id\n}\n",
    "metadata": {}
  }
};
})();
(node as any).hash = '2a8ea97c4c260c5b3e02970e0065ffb0';
export default node;
